<template>
    <div>
      {{ this.formattedDate }}
    </div>
  </template>
  
  <script>
  import Utils from "@/services/utils.js";
  
  export default {
    name: "DateRenderer",
    props: ["object", "columnKey"],
    computed: {
        formattedDate: function () {
            if(typeof this.object[this.columnKey] === 'object'){
                return Utils.momentLocalised(this.object[this.columnKey]).format('DD/MM/YYYY, HH:mm');
            }
            else{
                return this.object[this.columnKey];
            }
        }
    }
  };
  </script>
  